import ProtectedRoute from "@/auth/protectedroute";
import RedirectAuthenticated from "@/auth/redirectauthenticated";
import { RootLayout } from "@/layouts/RootLayout";
import LoginPage from "@/pages/auth/login";
import LogoutPage from "@/pages/auth/logout";
import OtpPage from "@/pages/auth/otp";
import SignupPage from "@/pages/auth/signup";
import Dashboard from "@/pages/dashboard";
import ProjectsPage from "@/pages/projects";
import ProjectDetailPage from "@/pages/projects/project";
import ProjectSettingsPage from "@/pages/projects/settings";
import { Settings } from "@/pages/settings/settings";
import { createBrowserRouter, Navigate } from "react-router";
export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <Navigate to="/projects" replace />,
          },
          {
            path: "settings",
            element: <Settings />,
          },
          {
            path: "projects",
            children: [
              {
                index: true,
                element: <ProjectsPage />,
              },
              {
                path: ":id",
                children: [
                  {
                    index: true,
                    element: <ProjectDetailPage />,
                  },
                  {
                    path: "settings",
                    element: <ProjectSettingsPage />,
                  },
                  {
                    path: "competitors/:competitorId",
                    element: <ProjectDetailPage />,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "/login",
        element: (
          <RedirectAuthenticated>
            <LoginPage />
          </RedirectAuthenticated>
        ),
      },
      {
        path: "/login/otp/",
        element: <OtpPage />,
      },
      {
        path: "/logout",
        element: <LogoutPage />,
      },
      {
        path: "/signup",
        element: (
          <RedirectAuthenticated>
            <SignupPage />
          </RedirectAuthenticated>
        ),
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);
